import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const PolicyFileIngestionSchema = z.object({
	fileName: z.string(),
	id: z.number(),
	importDate: z.date().nullable(),
	totalTax: z.number().default(0),
	totalPremium: z.number().default(0),
});

export type PolicyFileIngestion = z.infer<typeof PolicyFileIngestionSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
): Promise<{ data: PolicyFileIngestion[]; total: number }> => {
	try {
		let queryString = '';
		const searchParams = new URLSearchParams();

		if (pagination) {
			searchParams.append('pageSize', pagination.pageSize.toString());
			searchParams.append('pageIndex', pagination.pageIndex.toString());
		}

		if (sorting.length > 0) {
			searchParams.append('sortBy', sorting[0].id);
			searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
		}

		queryString = `?${searchParams.toString()}`;
		const response = await fetch(
			`/NorthLightPolicy${queryString}`,
		);
		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};
